import { render, staticRenderFns } from "./ElevateWellness.vue?vue&type=template&id=2a15e901"
import script from "./ElevateWellness.vue?vue&type=script&lang=js"
export * from "./ElevateWellness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports